import { render, staticRenderFns } from "./UrlToRole.vue?vue&type=template&id=9515f288&scoped=true"
import script from "./UrlToRole.vue?vue&type=script&lang=js"
export * from "./UrlToRole.vue?vue&type=script&lang=js"
import style0 from "./UrlToRole.vue?vue&type=style&index=0&id=9515f288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9515f288",
  null
  
)

export default component.exports